import { MarkerType, type Edge, type Node } from "@xyflow/react";
import type { CaseStepFold } from "@/types";
import type { StepNodeData } from "./StepNode";

// #303 (UC-3): die Ableitung des Ablauf-Bildes — PUR, ohne Zeichenfläche.
//
// Sie steht bewusst neben der Komponente: React Flow braucht eine echte Layout-Engine
// (`ResizeObserver`), die es im Test nicht gibt. Was hier entschieden wird — Reihenfolge,
// Zustand, welcher Übergang schon gelaufen ist — lässt sich damit trotzdem festnageln.

/** Waagerechte Kette. Ein Prozess wird gelesen wie ein Satz: von links nach rechts. */
export const ABSTAND_X = 210;

/** Ein Übergang gilt als gelaufen, wenn sein Ausgangs-Schritt hinter uns liegt. */
export function uebergangGelaufen(status: string): boolean {
  return status === "done" || status === "skipped";
}

export function baueGraph(
  steps: readonly CaseStepFold[],
  currentStepId: string | null,
): { nodes: Node<StepNodeData>[]; edges: Edge[] } {
  const nodes: Node<StepNodeData>[] = steps.map((s, i) => ({
    id: s.id,
    type: "schritt",
    position: { x: i * ABSTAND_X, y: 0 },
    // Der Betrachter soll die Karte lesen, nicht umbauen: kein Ziehen, kein Verbinden.
    draggable: false,
    connectable: false,
    data: {
      nummer: s.nummer,
      label: s.name ?? s.id,
      status: s.status,
      aktuell: s.id === currentStepId,
    },
  }));

  const edges: Edge[] = [];
  for (let i = 1; i < steps.length; i += 1) {
    const von = steps[i - 1]!;
    const nach = steps[i]!;
    // Die Kante zeigt den ZURÜCKGELEGTEN Weg, nicht bloss die Reihenfolge.
    const gelaufen = uebergangGelaufen(von.status);
    const farbe = gelaufen ? "var(--ok)" : "var(--border-strong)";
    edges.push({
      id: `${von.id}->${nach.id}`,
      source: von.id,
      target: nach.id,
      style: { stroke: farbe, strokeWidth: 2, ...(gelaufen ? {} : { strokeDasharray: "5 4" }) },
      markerEnd: { type: MarkerType.ArrowClosed, color: farbe },
    });
  }

  return { nodes, edges };
}
